<template>
        <div class="video-area" v-if="videoResult.length > 0">
                <strong @click="goVideoTab"><a href="javascript:;" target="_blank"  @click="countAd(4210)"><em>{{$global.q}}</em>的视频</a></strong>
                <ul class="ulPic2">
                    <li v-for="(item,index) in videoResult" :key="index">
                        <a :href="[item.v_type == 0 ? `//v.pcauto.com.cn/video-${item.id}.html` : `//v.pcauto.com.cn/album-${item.id}.html`]" target="_blank" :title="item.title.replace(/<[^>]+>/g, '')"  @click="countAd(4211)">
                        <div class="imgArea" style="opacity: 1;">
                            <img :src="item.v_thumb_180_url" />
                            <i></i>
                        </div>
                        <p class="tt" v-html="item.title"></p>
                        <em class="yc" v-if="item.original"></em>
                        </a>
                    </li>
                </ul>
               <a href="javascript:;" @click="goVideoTab(2)" target="_blank" class="moreLink" >更多视频 &gt;&gt;</a>
        </div>
</template>

<script>
export default {
    name: 'VideoArea',
    props: {
        videoResult : {
            type: Array,
            default: () => ({})
        }
    },
    methods: {
        goVideoTab(flag) {
            if(flag === 2) {
                this.countAd(4212)
                window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?tab=auto_video&q=${this.$global.q}`)
            }else {
                window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?tab=auto_video&q=${this.$global.q}`)
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.video-area {
    margin-top: 25px;
    font-size: 12px;
    strong {
        font-weight: normal;
        font-size: 16px;
        line-height: 32px;
        a {
            text-decoration: underline;
            color: #225599;
            em {
                color: #cc0000;
                text-decoration: underline;
                font-style: normal;
            }
        }
    }
    .ulPic2 {
        margin-left: -47px;
        width: 668px;
        display: flex;
        li {
            margin-left: 47px;
            width: 120px;
            display: inline;
            position: relative;
            a {
                color: #225599;
                cursor: pointer;
            }
            img {
                width: 120px;
                height: 68px;
            }
            i {
                display: block;
                width: 23px;
                height: 23px;
                background: url(//www1.pcauto.com.cn/2014/kuaisou/images/sp.png) no-repeat;
                position: absolute;
                right: 5px;
                top: 40px;
            }
            p {
                line-height: 18px;
                padding-top: 7px;
                height: 36px;
                overflow: hidden;
            }
            .tt {
                ::v-deep em {
                    color: #cc0000;
                    font-style: normal;
                }
            }
            .yc {
                position: absolute;
                width: 42px;
                height: 42px;
                background: url(//www1.pcauto.com.cn/20150115/kuaisou/images/img100.png) no-repeat;
                left: 0;
                top: 0;
            }
        }
    }
    .moreLink {
        color: #225599;
        margin-top: 10px;
        display: inline-block;
    }
}
</style>
